import { Chart } from "highcharts-vue";
import BrasilRegiao from "../MapasGeoJson/BrasilRegiao.json";
import BrasilEstado from "../MapasGeoJson/BrasilEstado.json";

import Highchart from "highcharts";
import HighchartsMapModule from "highcharts/modules/map";

HighchartsMapModule(Highchart);

export default {
  components: {
    highcharts: Chart
  },
  data() {
    return {
      chartOptions: {
        caption: {
          text: `<div class="texto-mapa cor-fonte texto"> No mapa a porcentagem mostrada é referente ao total de prestadores, naquela região do Brasil</div>`,
          floating: true,
          useHTML: true,
          align: "right",
          y: 0,
          x: 20
        },

        chart: {
          spacingRight: 50
        },

        title: {
          text: ""
        },

        credits: {
          enabled: false
        },

        mapNavigation: {
          enabled: false
        },

        tooltip: {
          animation: false,
          shared: false,
          formatter: function() {
            if (!this.point) return "";
            return `${this.point.properties.nome}: ${this.point.porcentagem}%`;
          },
          backgroundColor: "#1DAA7D",
          borderColor: "white",
          style: {
            color: "white",
            fontSize: "14px"
          },
          followPointer: false,
          hideDelay: 150,
          borderRadius: 6
        },

        colorAxis: {
          tickPixelInterval: 100,
          showInLegend: false
        },

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 700
              },
              chartOptions: {
                legend: {
                  align: "left",
                  verticalAlign: "bottom",
                  layout: "horizontal",
                  floating: false,
                  y: 0
                },
                chart: {
                  height: 500
                },
                caption: {
                  floating: false,
                  align: "left"
                }
              }
            }
          ]
        },

        legend: {
          y: 36,
          floating: true,
          verticalAlign: "bottom",
          itemStyle: {
            fontWeight: "normal",
            fontFamily: "Trebuchet MS",
            color: "#9e9e9e"
          },
          layout: "vertical",
          align: "left",
          symbolRadius: 4,
          itemMarginBottom: 26,
          symbolHeight: 16,
          symbolPadding: 12,
          itemHoverStyle: {
            color: "#60656c"
          },
          itemHiddenStyle: {
            cursor: "not-allowed",
            color: "#9E9E9E"
          },
          useHTML: true,
          labelFormatter: function() {
            const { name, value } = this.options.data[0];
            return (
              `<span  class="titulo-legenda-mapa"> ${name} </span>` +
              `<span class="valor-legenda-mapa" > ${value} </span>`
            );
          }
        },

        series: [
          {
            className: "serie-mapa",
            showInLegend: false,
            mapData: BrasilEstado,
            borderColor: "#FFFFFF",
            borderWidth: 0.5,
            data: [],
            keys: ["sigla", "value"],
            joinBy: "sigla",
            name: "",
            cursor: "pointer",
            states: {
              hover: {
                color: "#1DAA7D",
                borderColor: "#245F40",
                enabled: false
              },
              inactive: {
                enabled: true
              },
              normal: {
                animation: false
              }
            },
            dataLabels: {
              enabled: false
            },
            opacity: 1,
            point: {
              events: {
                click: ev => {
                  if (ev.point.state === "inactive") return;

                  this.limparEstado();
                }
              }
            }
          },
          {
            className: "serie-mapa",
            showInLegend: false,
            // cursor: "pointer",
            backgroundColor: "red",
            mapData: BrasilRegiao,
            data: [],
            joinBy: "sigla",
            name: "",
            cursor: "pointer",
            states: {
              hover: {
                color: "#a4edba",
                enabled: false
              },
              inactive: {
                enabled: true
              }
            },
            dataLabels: {
              enabled: false
            },
            opacity: 0,
            point: {
              events: {
                mouseOver: ev => {
                  this.mouseOverRegiao(ev);

                  if (this.regiaoClicada !== null) {
                    this.marcarRegiao();
                  }
                },
                mouseOut: () => {
                  this.mouseOutRegiao();
                },
                click: ev => {
                  this.clickRegiao(ev.point, true);
                }
              }
            }
          }
        ]
      }
    };
  }
};
